import { ConfigProvider } from "antd";
import { useTheme } from "@hooks/useTheme"; // adjust path if needed

export default function AntdThemeWrapper({ children }) {
  const { isDark } = useTheme();

  const themeConfig = {
    lightToken: {
      colorPrimary: "#575DF0",
      borderRadius: 12,
      fontSize: 14,
      fontFamily: "'Poppins', sans-serif",
      controlHeight: 44,
      colorBgContainer: "#fff",
      colorText: "#000",
      activeBorderColor:"red"
    },
    darkToken: {
      colorPrimary: "#575DF0",
      borderRadius: 12,
      fontSize: 14,
      fontFamily: "'Poppins', sans-serif",
      controlHeight: 44,
      colorBgContainer: "#000",
      colorText: "#F9FAFB",
    },
    components: {
      Input: { activeBorderColor: "#575DF0", hoverBorderColor: "#575DF0" },
      Select: {
        optionHeight: 34,          // default is ~32
        optionPadding: "4px 12px",
        
        colorBgElevated: isDark ? "#000" : "#fff",
        optionSelectedBg: isDark ? "#333" : "#e6f4ff",
        optionActiveBg: isDark ? "#1a1a1a" : "#f0f0f0",

        // Option text
        colorTextDisabled: "#666",
        activeBorderColor: "#575DF0", 
        hoverBorderColor: "#575DF0",
        fontSize: 14
      },
      DatePicker: {
         colorTextDisabled: "#666",
        // Calendar Panel
        colorBgElevated: isDark ? "#000" : "#fff",
        cellHoverBg: isDark ? "#1a1a1a" : "#f5f5f5",
        cellSelectedBg: isDark ? "#333" : "#1677ff22",
        cellSelectedColor: isDark ? "#fff" : "#000",

        // Icons (month/year arrows)
        colorIcon: isDark ? "#fff" : "#000",
        hoverColorIcon: isDark ? "#1677ff" : "#1677ff",
        // Responsive height
        controlHeightSM: 18,
      },
      InputNumber: { activeBorderColor: "#575DF0", hoverBorderColor: "#575DF0" },
      Tooltip: { controlHeight: 24 },
      Collapse: { headerBg: "#D1D5DB" },
      Pagination: { itemActiveBg: "#575DF0", colorBgTextActive: "#ffff" },
      Tabs: {
        itemSelectedColor: "#575DF0",
        itemHoverColor: "#575DF0",
        itemActiveColor: "#575DF0",
        inkBarColor: "#575DF0",
      },
      Button: { colorBgContainer: "none" },
    },
  };

  return (
    <ConfigProvider
      theme={{
        token: isDark ? themeConfig.darkToken : themeConfig.lightToken,
        components: themeConfig.components,
      }}
    >
      {children}
    </ConfigProvider>
  );
}
